import { KeyboardEvent } from 'react'
import { imDfmFeedback_quoteModelRevision_dfmFeedback as ImDfmFeedbackType } from '@Admin/AdminQuotingPage/ImDfmSlidesPanel/__generated__/imDfmFeedback'

export const handleKeyDown = (
    evt: KeyboardEvent,
    dfmFeedback: ImDfmFeedbackType[],
    activeSlideId: string | null,
    setActiveSlideId: (dfmFeedbackId: string) => void,
): void => {
    const { keyCode } = evt

    const selectedSlideId = dfmFeedback.findIndex(
        dfm => activeSlideId === dfm.id,
    )

    const isNotOnFirstSlide = !isNaN(selectedSlideId) && selectedSlideId !== 0
    const isNotOnLastSlide =
        !isNaN(selectedSlideId) && selectedSlideId !== dfmFeedback.length - 1

    if ((keyCode === 39 || keyCode === 40) && isNotOnLastSlide) {
        setActiveSlideId(dfmFeedback[selectedSlideId + 1]?.id)
    } else if ((keyCode === 37 || keyCode === 38) && isNotOnFirstSlide) {
        setActiveSlideId(dfmFeedback[selectedSlideId - 1]?.id)
    }
}
